import { Tag } from 'antd'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import useResidentNeeds from 'hooks/useResidentNeeds'

type NeedsContainerProps = {
  residentId: string
}

const NeedsContainer = ({ residentId }: NeedsContainerProps) => {
  const { needs, isLoading } = useResidentNeeds({ id: residentId })

  if (isLoading) return null

  return (
    <StyledNeedsContainer>
      {needs?.map((need) => (
        <StyledTag key={need.needName}>
          <Text weight="medium" level={2}>
            {need.needName}
          </Text>
        </StyledTag>
      ))}
    </StyledNeedsContainer>
  )
}

const StyledTag = styled(Tag)`
  padding: 4px 8px;
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.color.neutral.color3};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
`

const StyledNeedsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
`

export default NeedsContainer
